<script setup>
import { WdsAvatar } from '@wds/components';

defineProps({
  user: {
    type: String,
    required: true,
  },
  reviewText: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="trust-cues-card">
    <WdsAvatar
      class="trust-cues-card-user"
      :user-name="user"
    />
    <span class="trust-cues-card-text">
      {{ reviewText }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.trust-cues-card {
  display: inline-flex;
  flex-direction: column;
  gap: $wds-spacing-m;
  padding: $wds-spacing-xl $wds-spacing-l;
  border-radius: $wds-border-radius-l;
  background-color: $wds-color-white;
  box-shadow:
    inset 0 0 0 wds-rem(1px) $wds-color-ink-lightest,
    $wds-shadow-light-m;

  .trust-cues-card-text {
    color: $wds-color-ink-darker;

    @include body-2-reg;
  }
}
</style>
